import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { showInviteModal } from '../../actions/inviteActions';
import { requestCreditRedemption } from '../../actions/creditRedemptionActions';
import CreditRedemptionModal from '../../components/CreditRedemptionModal';

export class CreditRedemptionStatus extends React.Component {
  static propTypes = {
    query: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    // eslint-disable-next-line react/require-default-props
    show: PropTypes.bool.isRequired,
    success: PropTypes.bool,
    title: PropTypes.string,
    body: PropTypes.string,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        level: PropTypes.oneOf(['primary', 'secondary']).isRequired,
        action_type: PropTypes.oneOf(['url', 'custom']),
        action: PropTypes.string,
      }),
    ),
    breakdownButtons: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        level: PropTypes.oneOf(['primary', 'secondary']).isRequired,
        action_type: PropTypes.oneOf(['url', 'custom']),
        action: PropTypes.string,
      }),
    ),
    details: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(['header', 'table', 'list']).isRequired,
        title: PropTypes.string,
        subtitle: PropTypes.string,
        heading: PropTypes.string,
        items: PropTypes.oneOfType([
          PropTypes.arrayOf(
            PropTypes.shape({
              key: PropTypes.string.isRequired,
              value: PropTypes.string.isRequired,
            }).isRequired,
          ),
          PropTypes.arrayOf(PropTypes.string),
        ]),
      }).isRequired,
    ),
    creditRedemption: PropTypes.func.isRequired,
    onInviteButtonClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    show: false,
    success: undefined,
    title: undefined,
    body: undefined,
    buttons: [],
    breakdownButtons: [],
    details: [],
  };

  componentDidMount() {
    const { query, creditRedemption } = this.props;

    if (query.redeem_credit_token) {
      creditRedemption(query.redeem_credit_token);
    }
  }

  render() {
    const {
      show,
      success,
      title,
      body,
      buttons,
      breakdownButtons,
      details,
      onInviteButtonClick,
    } = this.props;

    if (!show) return null;

    return (
      <CreditRedemptionModal
        success={success}
        title={title}
        body={body}
        buttons={buttons}
        breakdownButtons={breakdownButtons}
        details={details}
        inviteFriendsHandler={onInviteButtonClick}
      />
    );
  }
}

export default connect(
  (state) => ({
    query: state.request.currentQuery,
    show: state.creditRedemption.show,
    success: state.creditRedemption.success,
    title: state.creditRedemption.title,
    body: state.creditRedemption.body,
    buttons: state.creditRedemption.buttons,
    breakdownButtons: state.creditRedemption.breakdownButtons,
    details: state.creditRedemption.details,
  }),
  (dispatch) => ({
    creditRedemption: (creditToken) => dispatch(requestCreditRedemption(creditToken)),
    onInviteButtonClick: () => dispatch(showInviteModal()),
  }),
)(CreditRedemptionStatus);
